// extracted by mini-css-extract-plugin
export default {"parent":"Feed_parent__wUqso","content":"Feed_content__VIjep"};